import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'primary';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  /** Show the leading status dot. Status must never be colour-alone (§4.3). */
  dot?: boolean;
  /** Optional leading icon (overrides the dot). */
  icon?: ReactNode;
  size?: 'sm' | 'md';
  children: ReactNode;
}

/** Status pill: tone + label, optionally a dot/icon. Never colour alone. */
export function Badge({ tone = 'neutral', dot = false, icon, size = 'md', className, children, ...rest }: BadgeProps) {
  return (
    <span className={cx('tc-badge', `tc-badge--${tone}`, size === 'sm' && 'tc-badge--sm', className)} {...rest}>
      {icon ?? (dot ? <span className="tc-badge__dot" aria-hidden /> : null)}
      {children}
    </span>
  );
}
